import React from 'react';
import { Helmet } from 'react-helmet';

interface IProps {
  title?: string;
  matomoTag?: string
}

const MetaDatas = (props: IProps) => (
  <Helmet>
    <meta charSet="utf-8" />
    <meta name="robots" content={'noindex,nofollow'} />
    <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no" />
    <meta http-equiv='cache-control' content='no-cache' />
    <meta http-equiv='expires' content='0' />
    <meta http-equiv='pragma' content='no-cache' />

    <link rel="manifest" href={process.env.PUBLIC_URL + '/manifest.json'} />
    <link rel="icon" href={process.env.PUBLIC_URL + '/favicon.Icon'} />
    <meta name="theme-color" content="#000000" />
    <meta name="description" content="My Bessé" />
    <link href="https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap" rel="stylesheet" />
    <link rel="icon" href="../../favicon.ico" />
    <title>{props.title || 'My Bessé'}</title>
    {
      props.matomoTag && sessionStorage.getItem('matomoTrackingEnabled') === 'true' &&
      <script type="text/javascript">
        {`
        window._paq = window._paq || [];
        window._paq.push(['trackPageView']);
        window._paq.push(['enableLinkTracking']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src='https://pbcanalytics.cabinet-besse.net/js/container_${props.matomoTag}.js'; s.parentNode.insertBefore(g,s);
      `}
      </script>
    }
  </Helmet>
);
export default MetaDatas;
